<template>
    <v-card>
        <v-card-title>
            <v-icon color="primary"> mdi-information </v-icon>
            <span class="pl-2">Facility Manager Information</span>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Passengers</p>
                    <div class="mt-4">
                        <p>{{ school.student_count }}</p>
                    </div>
                </v-col>
                <!-- drivers -->
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Drivers</p>
                    <div class="mt-4">
                        <p>{{ school.driver_count }}</p>
                    </div>
                </v-col>
                <!-- buses -->
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Vehicles</p>
                    <div class="mt-4">
                        <p>{{ school.bus_count }}</p>
                    </div>
                </v-col>

                <!-- stops -->
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Stops</p>
                    <div class="mt-4">
                        <p>{{ school.stop_count }}</p>
                    </div>
                </v-col>

                <!-- routes -->
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Routes</p>
                    <div class="mt-4">
                        <p>{{ school.route_count }}</p>
                    </div>
                </v-col>

                <!-- trips -->
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Trips</p>
                    <div class="mt-4">
                        <p>{{ school.trip_count }}</p>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <v-row>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Facility Name</p>
                    <div class="mt-4">
                        <p>{{ school.facility_name }}</p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">ZipCode</p>
                    <div class="mt-4">
                        <p>{{ school.zipcode }}</p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Fax</p>
                    <div class="mt-4">
                        <p>{{ school.fax }}</p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Mailbox</p>
                    <div class="mt-4">
                        <p>{{ school.mailbox }}</p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Expiry Date</p>
                    <div class="mt-4">
                        <p>{{ school.expiry_date }}</p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Id Type</p>
                    <div class="mt-4">
                        <p>{{ school.id_type }}</p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">ID Number</p>
                    <div class="mt-4">
                        <p>{{ school.id_number }}</p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Commercial Registration Number</p>
                    <div class="mt-4">
                        <p>{{ school.commercial_registration_number }}</p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Educational Transport Operation Card Number</p>
                    <div class="mt-4">
                        <p>{{ school.educational_transport_operation_card_number }}</p>
                    </div>
                </v-col>
                <v-col cols="12" md="4">
                    <p class="font-weight-bold">Educational Transport Operation Card Expiry Date</p>
                    <div class="mt-4">
                        <p>{{ school.educational_transport_operation_card_expiry_date }}</p>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-text>
            <v-row>

                <!-- Students -->
                <v-col cols="12" md="12">
                    <p class="font-weight-bold text-h6 mb-4">Passengers</p>
                    <v-data-table v-if="school.students.length" :headers="[
                        { text: 'ID', value: 'id' },
                        { text: 'Name', value: 'name' },
                        { text: 'Email', value: 'email' }
                    ]" :items="school.students" class="elevation-1" dense>
                        <template #item.email="{ item }">
                            <span v-if="item.email">{{ item.email }}</span>
                            <span v-else class="text--disabled">No email</span>
                        </template>
                    </v-data-table>
                    <div v-else>
                        <v-alert type="info" dense text>No passengers found.</v-alert>
                    </div>
                </v-col>

                <!-- Drivers -->
                <v-col cols="12" md="12">
                    <p class="font-weight-bold text-h6 mb-4">Drivers</p>
                    <v-data-table v-if="school.drivers.length" :headers="[
                        { text: 'ID', value: 'id' },
                        { text: 'Name', value: 'name' },
                        { text: 'Email', value: 'email' }
                    ]" :items="school.drivers" class="elevation-1" dense>
                        <template #item.email="{ item }">
                            <span v-if="item.email">{{ item.email }}</span>
                            <span v-else class="text--disabled">No email</span>
                        </template>
                    </v-data-table>
                    <div v-else>
                        <v-alert type="info" dense text>No drivers found.</v-alert>
                    </div>
                </v-col>

                <!-- Buses -->
                <v-col cols="12" md="12">
                    <p class="font-weight-bold text-h6 mb-4">Vehicles</p>
                    <v-data-table v-if="school.buses.length" :headers="[
                        { text: 'ID', value: 'id' },
                        { text: 'License', value: 'license' },
                        { text: 'Capacity', value: 'capacity' }
                    ]" :items="school.buses" class="elevation-1" dense>
                        <template #item.license="{ item }">
                            <span v-if="item.license">{{ item.license }}</span>
                            <span v-else class="text--disabled">No license number</span>
                        </template>
                    </v-data-table>
                    <div v-else>
                        <v-alert type="info" dense text>No vehicles found.</v-alert>
                    </div>
                </v-col>

                <!-- Stops -->
                <v-col cols="12" md="12">
                    <p class="font-weight-bold text-h6 mb-4">Stops</p>
                    <v-data-table v-if="school.stops.length" :headers="[
                        { text: 'ID', value: 'id' },
                        { text: 'Name', value: 'name' },
                        { text: 'Email', value: 'email' }
                    ]" :items="school.stops" class="elevation-1" dense>
                        <template #item.email="{ item }">
                            <span v-if="item.email">{{ item.email }}</span>
                            <span v-else class="text--disabled">No email</span>
                        </template>
                    </v-data-table>
                    <div v-else>
                        <v-alert type="info" dense text>No stops found.</v-alert>
                    </div>
                </v-col>

                <!-- Routes -->
                <v-col cols="12" md="12">
                    <p class="font-weight-bold text-h6 mb-4">Routes</p>
                    <v-data-table v-if="school.routes.length" :headers="[
                        { text: 'ID', value: 'id' },
                        { text: 'Name', value: 'name' },
                        { text: 'Email', value: 'email' }
                    ]" :items="school.routes" class="elevation-1" dense>
                        <template #item.email="{ item }">
                            <span v-if="item.email">{{ item.email }}</span>
                            <span v-else class="text--disabled">No email</span>
                        </template>
                    </v-data-table>
                    <div v-else>
                        <v-alert type="info" dense text>No routes found.</v-alert>
                    </div>
                </v-col>

                <!-- Trips -->
                <v-col cols="12" md="12">
                    <p class="font-weight-bold text-h6 mb-4">Trips</p>
                    <v-data-table v-if="school.trips.length" :headers="[
                        { text: 'ID', value: 'id' },
                        { text: 'Name', value: 'name' },
                        { text: 'Email', value: 'email' }
                    ]" :items="school.trips" class="elevation-1" dense>
                        <template #item.email="{ item }">
                            <span v-if="item.email">{{ item.email }}</span>
                            <span v-else class="text--disabled">No email</span>
                        </template>
                    </v-data-table>
                    <div v-else>
                        <v-alert type="info" dense text>No trips found.</v-alert>
                    </div>
                </v-col>

            </v-row>
        </v-card-text>

    </v-card>
</template>

<script>
import AvatarImageComponent from "../../components/AvatarImageComponent.vue";

export default {
    name: "schoolCard",
    props: {
        school: {
            type: Object,
            required: true,
        },
    },
    components: {
        AvatarImageComponent,
    },
};
</script>
